import React from 'react';
import { Text as RebassText } from 'rebass';

const Text = props => <RebassText as="p" fontSize={[2, 2, 2, 4]} mb="3" {...props} />;

export default Text;
